<template>
  <div class="video-content">
    <div class="bread-crumb-wrap">
      <!-- 1/2/3 -->
    </div>
    <div class="content-wrap">
      <div class="content">
        <div class="main-content">
          <div class="video-player-wrap">
            <d-player ref="player" class="d-player" :options="options" />
          </div>
          <p class="detail-summary" @click="showDialog = true">
            {{ langTransfer(detailData.introduction) }}
          </p>
        </div>
        <div class="catalog-wrap">
          <div class="name-active">
            <div class="name text1line">
              {{ langTransfer(detailData.name) }}
            </div>
            <div
              v-show="webInfo.isAllowLogin == '1' && detailData.name"
              class="add-btn-wrap lr-img-scale"
            >
              <div @click="collect">
                <LottieAddBtn
                  :is-collection="detailData.follow_state === '1'"
                />
              </div>
            </div>
          </div>
          <div class="list-wrap">
            <bscroll-view>
              <div class="list-content">
                <div
                  v-for="(item, index) in listData"
                  :key="index"
                  class="item"
                  :class="{ 'is-playing-item': listIndex === index }"
                  @click="videoListClick(item, index)"
                >
                  <img
                    :src="
                      isPlaying
                        ? require('@/assets/img/audio/pause-black.png')
                        : require('@/assets/img/play-black.png')
                    "
                  />
                  <i>
                    {{ `0${index + 1}`.substr(-2) }}
                  </i>
                  <p class="text1line">
                    {{ langTransfer(item.title) }}
                  </p>
                  <span>
                    {{ countTime(item.duration) }}
                  </span>
                </div>
              </div>
            </bscroll-view>
          </div>
        </div>
        <el-popover
          v-show="qrcodeObj"
          placement="top-start"
          trigger="hover"
          :offset="0"
          popper-class="qrcode-popover"
        >
          <div class="common-qrcode-content">
            <div ref="qrcode" />
          </div>
          <img
            slot="reference"
            class="common-qrcode-popover"
            src="@/assets/img/qrcode.png"
          />
        </el-popover>
      </div>
    </div>
    <footer-com />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import BscrollView from "@/components/bscrollView";
import LottieAddBtn from "@/components/lottieActions/add";
import FooterCom from "@/components/footerCom/footerCom";
import dPlayer from "vue-dplayer";
import { detail, audioCatalogList, qrCode, icityCollect } from "../../api/lyl";
import "vue-dplayer/dist/vue-dplayer.css";

export default {
  name: "Home",
  components: {
    dPlayer,
    FooterCom,
    BscrollView,
    LottieAddBtn,
  },
  data() {
    return {
      listIndex: 0,
      listData: [],
      videoDomInfo: {
        d: 0,
        s: 0,
      },
      detailData: "",
      player: null,
      options: {
        video: {
          url: "",
        },
        poster: "",
        contextmenu: [{}],
      },
      qrcodeObj: undefined,
      breadcrumbData: [],
      isPlaying: false,
    };
  },
  computed: {
    pageSetup() {
      return this.$store.state.pageSetup;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
    user_unique_code() {
      return this.$store.state.user_unique_code;
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.detail();
        this.audioCatalogList();
      }
    },
  },
  mounted() {
    const { service_code } = this.webInfo;
    if (service_code) {
      this.detail();
      this.getQrcode();
    }
  },
  methods: {
    initQrCode(text) {
      const ele = this.$refs.qrcode;
      ele.innerHTML = "";
      this.qrcodeObj = new QRCode(ele, {
        width: 110,
        height: 110,
        text,
      });
    },
    async getQrcode() {
      try {
        const { id } = this.$route.params;
        const data = await qrCode({
          type: 5,
          service_code: this.webInfo.service_code,
          id,
          user_unique_code: this.user_unique_code,
        });
        this.initQrCode(data);
        this.collectCollect()
      } catch (err) {
        console.log(err);
      }
    },
    collectCollect(e){
      let program_id = this.listData[e].order_number == undefined ? null : this.listData[e].order_number;
      let program_name = this.listData[e].title == undefined ? null : this.listData[e].title;
      icityCollect({
        serviceCode: this.webInfo.service_code,
        // type: 22,
        resourceCode: this.detailData.id,
        resourceName: this.detailData.name,
        programId: program_id,
        programName: program_name,
        // author: this.detailData.author,
        platformName:'精品阅览室pc端',
        resourceType:5,
        operationType:1
        })
    },
    // 目录
    async audioCatalogList() {
      try {
        const { id } = this.$route.params;
        const data = await audioCatalogList({
          service_code: this.webInfo.service_code,
          id,
        });
        this.listData = data;
        this.player = this.$refs.player.dp;
        this._setVideoUrl(this.listData[0].link_url, this.listData[0]);
        if (!this.player.video) {
          return;
        }
        this.player.video.addEventListener("play", () => {
          this.isPlaying = true;
        });
        this.player.video.addEventListener("pause", () => {
          this.isPlaying = false;
        });
      } catch (err) {
        console.log(err);
      }
      this.collectCollect(0)
    },
    // 列表
    async detail() {
      try {
        const { id } = this.$route.params;
        const data = await detail({
          service_code: this.webInfo.service_code,
          type: "5",
          id,
          user_unique_code: this.user_unique_code,
        });
        this.detailData = data;
        this.initBreadcrumbData();
        this.audioCatalogList();
      } catch (err) {
        console.log(err);
      }
    },
    countTime(val) {
      if (!val) {
        return "00:00:00";
      }
      let h;
      let m;
      let s;
      if (val >= 0) {
        h = Math.floor(val / 60 / 60);
        m = Math.floor((val / 60) % 60);
        s = Math.floor(val % 60);
        if (s < 10) {
          s = `0${s}`;
        }
        if (m < 10) {
          m = `0${m}`;
        }
        if (h < 10) {
          h = `0${h}`;
        }
      } else {
        return false;
      }
      return `${h}:${m}:${s}`;
    },
    videoListClick(v, i) {
      this.collectCollect(i);
      this.listIndex = i;
      this._setVideoUrl(v.link_url, v);
      this.$nextTick(() => {
        if (!this.player.video) {
          return;
        }
        this.player.video.play();
      });
    },
    // 设置视频播放路径
    _setVideoUrl(url, item) {
      this.player.switchVideo({
        url,
      });
      this.options.poster = item.poster;
      setTimeout(() => {
        this.videoDomInfo.d = document.getElementsByClassName(
          "dplayer-video"
        )[0].duration;
      }, 800);
    },
    collect() {
      const { id: res_code } = this.$route.params;
      const formData = {
        type: 11,
        res_code,
        user_unique_code: this.user_unique_code,
      };
      const callback = (bool) => {
        if (bool) {
          this.detailData.follow_state = "2";
        } else {
          this.detailData.follow_state = "1";
        }
      };
      this.$utils.userCollect(formData, callback);
    },
    // 时间转换
    secondToDate(val) {
      // var h = Math.floor(val / 3600),
      const m = Math.floor(val / 60);
      const s = Math.floor(val % 60);
      //自己判断了...
      return `${m}:${s}`;
    },
    initBreadcrumbData() {
      const { query } = this.$route;
      if (!query.p1FullPath || !query.p0FullPath) {
        return;
      }
      this.breadcrumbData = [
        {
          path: query.p1FullPath,
          name: query.p1Name,
        },
        {
          path: query.p0FullPath,
          name: query.p0Name,
        },
        {
          name: this.detailData.name || "音频详情",
        },
      ];
    },
  },
};
</script>

<style scoped lang="less">
// .content .d-player{
//     width: 600px !important;
//     height: 350px !important;
// }
.video-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.bread-crumb-wrap {
  width: 1200px;
  font-size: 13px;
  font-family: AlibabaPuHuiTiM;
  color: #909399;
  line-height: 20px;
  margin: 20px 0;
}

.content-wrap {
  width: 100%;
  flex: 1;
  overflow: hidden;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
}

.content {
  width: 1200px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  z-index: 1;

  .main-content {
    width: 800px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .video-player-wrap {
    width: 800px;
    height: 450px;
  }
  @media screen and (max-width: 10000px) {
    .d-player {
    width: 800px;
    height: 450px;
  }
  }
  @media screen and (max-width: 1280px) {
    .d-player {
    width: 700px;
    height: 350px;
  }
  }


  .detail-summary {
    font-size: 13px;
    font-family: AlibabaPuHuiTiR;
    color: #909399;
    line-height: 20px;
    margin-top: 20px;
  }

  .catalog-wrap {
    width: 400px;
    height: 450px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .name-active {
    width: 100%;
    height: 68px;
    box-sizing: border-box;
    padding: 0 20px;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }

  .name {
    flex: 1;
    font-size: 15px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    line-height: 24px;
  }

  .add-btn-wrap {
    width: 80px;
    height: 36px;
    margin-left: 20px;
    background: #303133;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 18px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
}

.list-header {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 0 20px;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 12px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    line-height: 20px;
  }

  span {
    margin-left: 4px;
  }
}

.list-wrap {
  width: 100%;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.list-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-bottom: 30px;

  .item {
    width: 100%;
    height: 44px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;

    i {
      display: block;
      width: 60px;
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
      text-align: center;
      font-style: normal;
    }

    img {
      width: 24px;
      height: 24px;
      margin: 0 18px;
      display: none;
    }

    p {
      flex: 1;
      margin: 0 10px;
      font-size: 15px;
      font-family: AlibabaPuHuiTiM;
      color: #606266;
      line-height: 24px;
    }

    span {
      display: block;
      width: 80px;
      font-size: 12px;
      font-family: AlibabaPuHuiTiM;
      color: #909399;
      line-height: 24px;
      margin-right: 20px;
      text-align: right;
    }
  }

  .is-playing-item {
    background: #f5f7fa;

    i {
      display: none;
    }

    img {
      display: block;
    }
  }
}
</style>
